import CrossSellingEnum from '../../enumerators/single/cross-selling.enum'

export default class CrossSellingMapComponent {
    constructor() {
        CrossSellingMapComponent.filtersTrigger()
    }

    static filtersTrigger() {
        $(CrossSellingEnum.FILTERS_TRIGGER).click(() => {
            $(CrossSellingEnum.FILTERS).toggleClass('open')
        })
    }
}
